var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{attrs:{"background-image":"/images/oeffnungszeiten.jpg"}},[_c('div',{attrs:{"id":"oeffnungszeiten"}},[_c('div',[_c('h1',[_vm._v("Öffnungszeiten")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }